import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { MuslimInvestPaymentProducts } from "../../../types/MuslimInvest/MuslimInvestPaymentProducts";

export function useGetMuslimInvestPaymentProducts(enabled = true) {
  return useQuery({
    queryKey: ["muslim-invest-payment-products"],
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const res = await axiosInstance.get<MuslimInvestPaymentProducts>(
        getAPIURL("/MuslimInvestProfile/Payment/Products")
      );
      return res.data;
    },
  });
}
